import React, { Component } from 'react';

import './style.css';

export default class Footer extends Component {
  render() {
    return (
      <footer className='footer'>
        <div className='container'>
          <div className='row align-items-center'>
            <div className='col-md-4'>
              <span className='copyright'>
                Copyright &copy; Mohamed Khaled Portfolio 2023
              </span>
            </div>
            <div className='col-md-4'>
              <ul className='list-inline social-buttons'>
                <li className='list-inline-item'>
                  <a
                    href='https://github.com/Mk1499/'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <i className='fab fa-github'></i>
                  </a>
                </li>
                <li className='list-inline-item'>
                  <a
                    href='https://www.facebook.com/mohamed.khaled.114'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <i className='fab fa-facebook-f'></i>
                  </a>
                </li>
                <li className='list-inline-item'>
                  <a
                    href='http://linkedin.com/in/mk1499'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <i className='fab fa-linkedin-in'></i>
                  </a>
                </li>
                <li className='list-inline-item'>
                  <a
                    href='https://www.hackerrank.com/m_khaled1499'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <i className='fab fa-hackerrank'></i>
                  </a>
                </li>
                <li className='list-inline-item'>
                  <a
                    href='https://www.behance.net/mk1499'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <i className='fab fa-behance'></i>
                  </a>
                </li>
              </ul>
            </div>
            <div className='col-md-4'>
              <ul className='list-inline quicklinks'></ul>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}
